import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS

//////////////////////////////////////////////////////////////// Cookies
import CookiesMsg from './plugins/cookies-msg/index.js';
Vue.use(CookiesMsg);

//////////////////////////////////////////////////////////////// Site drawer
import SiteDrawer from './plugins/site-drawer/index.js';
Vue.use(SiteDrawer);

//////////////////////////////////////////////////////////////// Scroll To
import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo, {
    container: "body",
    duration: 750,
    easing: "ease",
    offset: -150,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

//////////////////////////////////////////////////////////////// Bootstrap Modal
import { ModalPlugin } from 'bootstrap-vue';
Vue.use(ModalPlugin);

//////////////////////////////////////////////////////////////// Bootstrap Collpase
import { CollapsePlugin } from 'bootstrap-vue'
Vue.use(CollapsePlugin)

/////////////////////////////////////////////////////////////////////////////////////////////////// APP
import Store from './store';
import Router from './router';
import PageLoader from './page-loader';
import SmoothScroll from './smooth-scroll';
// import CursorFollower from './components/cursor-follower';
import CountTo from 'vue-count-to';
import AccessibilityHelper from './components/accessibility-helper';

import {
    devices,
    isIOS,
    browser,
    viewportSize
} from './imports/utils';

if (document.getElementById('app')) {
    new Vue({
        el: '#app',
        store: Store,
        router: Router,
        mixins: [PageLoader, SmoothScroll], //PageLoader
        components: {
            // CursorFollower,
            CountTo,
            AccessibilityHelper
        },
        data() {
            return {
                isDevice: devices(),
                isIOS: isIOS(),
                browser: browser(),
                viewport: viewportSize(),
                mobileMenuOpen: false
            }
        },
        computed: {
            storeReady() {
                return !!this.$store.state.portfolio;
            }
        },
        methods: {
            onResize() {
                this.viewport = viewportSize();
            },
            onMenuOpen() {
                this.mobileMenuOpen = true;

                if (this.$route.name == 'home') {
                    this.$refs['view'].removeListeners();
                }
            },
            onMenuClose() {
                this.mobileMenuOpen = false;

                if (this.$route.name == 'home' && this.$refs['view'].addListeners) {
                    this.$refs['view'].addListeners();
                }
            }
        },
        created() {
            if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;');

            window.addEventListener("resize", this.onResize, {
                passive: false
            });
        },
        mounted() {
            if (this.isDevice || this.isIOS) {
                document.querySelector("html").classList.add("is-device");
            }

            if (this.browser == "Safari 14" || this.browser == "Safari 13") {
                document.querySelector("html").classList.add("safari-13-14");
            }
        },
        destroyed() {
            window.removeEventListener("resize", this.onResize);
        }
    })
}


// ================================ Pantelis "Dynamic Offer Page" Init. NON SPA PAGE ==============================================
import DynamicOfferForm from './DynamicOffers/DynamicOfferForm.vue'
// import DynamicOfferSlideshow from './DynamicOffers/DynamicOfferSlideshow.vue'
// import TopMediaTiles from './DynamicOffers/TopMediaTiles.vue'
import MarqueeGallery from './marquee-gallery.vue'

// Non-SPA Layout: mount 
if (document.getElementById('nonspa-app')) {

    new Vue({
        el: '#nonspa-app',
        components: { DynamicOfferForm, MarqueeGallery },
        data() {
            return {
                isDevice: devices(),
                isIOS: isIOS(),
                browser: browser(),
                viewport: viewportSize(),
                mobileMenuOpen: false
            }
        },
        methods: {
            onResize() {
                this.viewport = viewportSize();
            },
            onMenuOpen() {
                this.mobileMenuOpen = true;

                if (this.$route.name == 'home') {
                    this.$refs['view'].removeListeners();
                }
            },
            onMenuClose() {
                this.mobileMenuOpen = false;

                if (this.$route.name == 'home' && this.$refs['view'].addListeners) {
                    this.$refs['view'].addListeners();
                }
            }
        },
        created() {
            if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;');

            window.addEventListener("resize", this.onResize, {
                passive: false
            });
        },
        mounted() {
            if (this.isDevice || this.isIOS) {
                document.querySelector("html").classList.add("is-device");
            }

            if (this.browser == "Safari 14" || this.browser == "Safari 13") {
                document.querySelector("html").classList.add("safari-13-14");
            }
        },
        destroyed() {
            window.removeEventListener("resize", this.onResize);
        }
    })
}